const paymentOptionReducer = (state = 'Full', action) => {
	switch(action.type){
	case 'FULLAMOUNT':	
		return 'Full';
	case 'OTHERAMOUNT':
		return 'Other';
	case 'CLEARAMOUNT':
		return '';
	default:
		return state;
	}
}

export default paymentOptionReducer;